import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button';
import * as signinAction from 'yoda-checkout-components/lib/actions/SigninAction';
import { CONTINUE_AS_GUEST } from 'yoda-checkout-components/lib/common/LabelConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './ContinueAsGuest.css';

const cx = classnames.bind(styles);

export function ContinueAsGuest(props) {
    const doContinueAsGust = () => {
        props.actions.checkoutSessionInit();
    };

    return (
        <div className={`${cx('mainContainer')} ${dt(['flex', 'flex-col', 'mt-6'])}`}>
            <Button
                automationId="at-continue-as-guest"
                buttonType="Secondary"
                className={`${cx('continueAsGuestBtn')} ${dt([
                    'mb-7',
                    'w-full',
                    'block',
                    'lg:max-w-[300px]',
                    'mx-auto',
                ])}`}
                onClick={doContinueAsGust}
                size="Lg"
                isDisabled={props.showGlobalLoader}
            >
                {CONTINUE_AS_GUEST}
            </Button>
        </div>
    );
}

ContinueAsGuest.propTypes = {
    actions: PropTypes.objectOf(PropTypes.object).isRequired,
    showGlobalLoader: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign(signinAction), dispatch),
});
export default connect(null, mapDispatchToProps)(ContinueAsGuest);
